import type { BookingInterface } from "types/booking";
import roundNumber from "helpers/roundNumber";

class CalculOpperator {
    readonly MANAGEMENT_FEES = 2;
    readonly COMMISSION = 0.25;
    readonly TAX = 0.2;

    booking: BookingInterface | null;

    constructor(booking: BookingInterface | null) {
        this.booking = booking;
    }

    computeTTC(priceHT: number): [number, number] {
        const managementFeesValue = this.MANAGEMENT_FEES + priceHT * this.COMMISSION + ((this.MANAGEMENT_FEES + priceHT * this.COMMISSION) * this.TAX);
        return [roundNumber(managementFeesValue), roundNumber(priceHT + managementFeesValue)];
    }
}

export default CalculOpperator;
